import WithRender from "../../templates/layouts/layoutPersonalizationFullPageConfiguration.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getMatrixComplete"])
  }
});
